export const YouTubeIcon = ({
  width = 26,
  height = 26,
  fill = "none",
  className,
}: {
  width?: number;
  height?: number;
  fill?: string;
  className?: string;
}) => (
  <svg
    className={className}
    width={width}
    height={height}
    viewBox="0 0 58 58"
    fill={fill}
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      className={className}
      d="M57.4223 17.4001C57.4223 17.4001 56.8559 13.4013 55.1113 11.6454C52.9023 9.33447 50.4328 9.32314 49.3 9.18721C41.1891 8.59814 29.0113 8.59814 29.0113 8.59814H28.9887C28.9887 8.59814 16.8109 8.59814 8.7 9.18721C7.56719 9.32314 5.09766 9.33447 2.88867 11.6454C1.14414 13.4013 0.589062 17.4001 0.589062 17.4001C0.589062 17.4001 0 22.1013 0 26.7911V31.1864C0 35.8763 0.577734 40.5774 0.577734 40.5774C0.577734 40.5774 1.14414 44.5763 2.87734 46.3321C5.08633 48.6431 7.98633 48.5638 9.27774 48.813C13.9223 49.2548 29 49.3907 29 49.3907C29 49.3907 41.1891 49.3681 49.3 48.7903C50.4328 48.6544 52.9023 48.6431 55.1113 46.3321C56.8559 44.5763 57.4223 40.5774 57.4223 40.5774C57.4223 40.5774 58 35.8876 58 31.1864V26.7911C58 22.1013 57.4223 17.4001 57.4223 17.4001ZM23.0074 36.522V20.2208L38.6742 28.3997L23.0074 36.522Z"
    />
  </svg>
);
